import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { IntegrityMonitorPauseWebComponent } from '../component/IntegrityMonitorPauseWebComponents';
import { templateIntegrityMonitorPause } from '../view/template';
import { IntegrityMonitorPauseView } from '../view/IntegrityMonitorPauseView';
import { IntegrityMonitorPauseRepository } from '../repository/IntegrityMonitorPauseRepository';

export class IntegrityMonitorPauseController extends BaseWebComponentController {
  public view: IntegrityMonitorPauseView;
  public component: IntegrityMonitorPauseWebComponent;
  public duration: number;

  constructor(component: IntegrityMonitorPauseWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrityMonitorPauseView,
      viewTemplate: templateIntegrityMonitorPause,
      dataRepositoryConstructor: IntegrityMonitorPauseRepository,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$duration,
        event: 'change',
        callback: this.timeChangedHandler,
      },
      {
        element: this.view.dom.$cancelButton,
        event: 'click',
        callback: this.cancelButtonHandler,
      },
      {
        element: this.view.dom.$saveButton,
        event: 'click',
        callback: this.sendTask,
      },
    ];
  }

  private cancelButtonHandler() {
    this.component.dispatchEvent(
      new CustomEvent('clickOnCancelButton', {
        bubbles: true,
        composed: true,
      })
    );
  }

  private timeChangedHandler(event: CustomEvent) {
    const { hours, minutes } = event.detail.time;

    this.duration = hours * 3600 + minutes * 60;

    this.view.dom.$saveButton.disabled = this.duration === 0;
  }

  private async sendTask() {
    if (this.duration === 0) {
      return;
    }

    const request = { duration: this.duration };

    await this.dependencies.api.clients.Tasks.createTasks(request).toPromise();
  }

  async getDataForView() {
    const formValue = this.component.getFormValue();

    return { formValue };
  }
}
